var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doVIDEOFILE"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.cont.stem))]),_c('video',{attrs:{"src":_vm.cont.answer,"controls":"controls"}},[_vm._v(" your browser does not support the video tag\n")])])
}
var staticRenderFns = []

export { render, staticRenderFns }